import { Link } from "react-router-dom";
import { faLock, faRepeat } from "@fortawesome/pro-solid-svg-icons";
import { useQueryClient } from "@tanstack/react-query";
import { clsx } from "clsx";

import { T } from "@repo/transifex";
import { authActions, useAuth } from "~/providers/store/auth";

import { Button } from "./Button";

type AuthButtonsProps = {
  className?: string;
};

export const AuthButtons = ({ className }: AuthButtonsProps) => {
  const { isKanplaAdmin } = useAuth();

  const queryClient = useQueryClient();

  return (
    <div className={clsx("flex gap-2", className)}>
      {isKanplaAdmin ? (
        <Link to="/admin">
          <Button icon={faRepeat} size="large" variant="primary-light">
            <T _str="Mask till" />
          </Button>
        </Link>
      ) : null}

      <Button
        icon={faLock}
        onClick={() => {
          authActions.logout();
          queryClient.removeQueries();
        }}
        size="large"
        variant="dark-blue"
      >
        <T _str="Logout" />
      </Button>
    </div>
  );
};
